














import {Component, Prop, Vue} from "vue-property-decorator";

@Component({
    components: {
    }
})
export default class DecisionIconButtonComponent extends Vue {
    name = 'DecisionIconButtonComponent';
    @Prop()
    decisonType!: string;

}
